import * as React from 'react';
import {Dialog} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { traducirLabel } from '../../blocks/traductor';

interface Props {
    titulo: string
    contenido?: string
    abierto: boolean
    solicitud: () => void
    etiquetadora: () => void
    lasser: () => void
    cerrar: () => void
    maxWidth?: 'lg'| 'md'| 'sm'| 'xl'
}

const ImprimirDialog = ({titulo, contenido, abierto, solicitud, etiquetadora, lasser, cerrar, maxWidth}: Props) => {
    return (<>
        <Dialog open={abierto} maxWidth={maxWidth? maxWidth: "md"} fullWidth={true} onClose={cerrar}>
            <DialogTitle id="simple-dialog-title">{titulo}</DialogTitle>
            <DialogContent dividers>
                <DialogContentText>
                    {traducirLabel(199)}: {contenido}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={solicitud} variant="contained" color="primary">
                    {traducirLabel(339)}
                </Button>
                <Button onClick={etiquetadora} variant="contained" color="primary">
                    {traducirLabel(162)}
                </Button>
                <Button onClick={lasser} variant="contained" color="primary">
                    {traducirLabel(163)}
                </Button>
                <Button autoFocus onClick={cerrar} color="primary">
                {traducirLabel(340)}
                </Button>
            </DialogActions>
        </Dialog>
    </>)
};

export default ImprimirDialog;
